import { Injectable } from '@angular/core';

export type ThemeMode = 'light' | 'dark' | 'system';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'lc-theme';
  private _mode: ThemeMode = 'system';
  private _mq = window.matchMedia('(prefers-color-scheme: dark)');

  get mode(): ThemeMode {
    return this._mode;
  }

  init() {
    const saved = localStorage.getItem(this.STORAGE_KEY) as ThemeMode;
    this._mode = saved || 'system';
    this._mq.addEventListener('change', () => {
      if (this._mode === 'system') this.applyTheme();
    });
    this.applyTheme();
  }

  setMode(mode: ThemeMode) {
    this._mode = mode;
    localStorage.setItem(this.STORAGE_KEY, mode);
    this.applyTheme();
  }

  private applyTheme() {
    const isDark =
      this._mode === 'dark' ||
      (this._mode === 'system' && this._mq.matches);
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }
}
